import React from "react";
import {VideoTitle} from "../layout/Title";
import styled from "@emotion/styled/macro";
import {IVideoControls, IVideoPlayerStatus} from "../visualizer/VscVisualizerSession";


const VideoControlsDiv = styled.div`
  &.open {
    height:120px;
  }
  &.closed {
    height: 72px;
  }
  
  .videotitle {
    display:flex;
    align-items:center;
    flex: 0 0 40px;
    margin: 8px 0px;
  }
  
  .controls div {
    
    
    display:flex;
    flex-direction:row;
    width: 321.37px;
    justify-content:space-between;
    
    
  }
  
  .controls {
    overflow:hidden;
    transition: opacity .2s;
  }
  
  &.closed .controls { visibility: hidden; opacity: 0; }
  
  .chevron {
    transition: transform .2s;
  }
  &.closed .chevron {
    transform: rotate(180deg);
  }
  transition: height .2s;
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content:flex-start;
  width:100%;
`


type VideoAction = "restart" | "rewind" | "pause" | "ff" | "stop" | "resume";



const VideoButton: React.FC<{action:VideoAction, onClick: () => void}> = ({action, onClick}) => {
    return <img src={"/images/video" + action + ".svg"} onClick={(ev) => { ev.preventDefault(); ev.stopPropagation(); onClick(); return true;} } />
}

export const VscVideoControls: React.FC<{ videoControls: IVideoControls, videoStatus: IVideoPlayerStatus }> = (props) => {

    const {videoControls, videoStatus} = props;
    const paused = !videoStatus.isPlaying;


    if (videoStatus === undefined) return null;

    return <VideoControlsDiv className={"open"}>
        <div className={"videotitle"}>
            {/*shouldnt this be a prop? */}
            <VideoTitle> {videoStatus.title} </VideoTitle>
            <img className={"chevron"} src={"images/chevrondown.svg"} width={12} height={6}/>
        </div>
        <div className={"controls"}>
            <div>
                <VideoButton action={"restart"} onClick={() => {
                    videoControls.seek(0)
                }}/>

                <VideoButton action={"rewind"} onClick={() => { videoControls.seek(-15000, true)}} />
                {paused && <VideoButton action={"resume"} onClick={() => {
                    videoControls.setPaused(false);
                }}/>}
                {!paused && <VideoButton action={"pause"} onClick={() => {
                    videoControls.setPaused(true);
                }}/>}
                <VideoButton action={"ff"} onClick={() => { videoControls.seek(15000, true)}} />

            </div>
        </div>
    </VideoControlsDiv>
}